import { Table, TableBody, TableHeader, TableHeaderCell, TableRow } from "@braze/beacon-core"
import { AnalysisTableRow } from "./AnalysisTableRow"
import { useMemo, useState } from "react";
import { AnalysisCampaignObject } from "../../../types/APITypes";
import { useAnalysisContext } from "../../../contexts/AnalysisContext";


export const AnalysisTable = (() => {

    const { analysisCampaigns, showProjections } = useAnalysisContext();
    const [sortDirection, setSortDirection] = useState<{
        col: keyof AnalysisCampaignObject | undefined;
        dir: "asc" | "desc" | undefined | false;
      }>({
        col: undefined,
        dir: undefined,
      });
    
    const sorted = useMemo(() => {
        const { col, dir } = sortDirection;        
        if (!col || !dir) {
          return analysisCampaigns;
        }
        if (analysisCampaigns !== null) {
            return [...analysisCampaigns].sort((a, b) => {
                const aVal = a[col];
                const bVal = b[col];
                
                // Handle null/undefined values
                if (aVal == null && bVal == null) return 0;
                if (aVal == null) return 1;
                if (bVal == null) return -1;
                
                // Convert to numbers if they are numeric strings
                const aNum = typeof aVal === 'string' ? parseFloat(aVal) : aVal;
                const bNum = typeof bVal === 'string' ? parseFloat(bVal) : bVal;
                
                if (dir === "asc") {
                    if (aNum > bNum) {
                        return 1;
                    }
                    if (aNum < bNum) {
                        return -1;
                    }
                } else if (dir === "desc") {
                    if (aNum > bNum) {
                        return -1;
                    }
                    if (aNum < bNum) {
                        return 1;
                    }
                }
                return 0;
            });
        }
        
    }, [analysisCampaigns, sortDirection]);

    const handleSortClick = (
        col : keyof AnalysisCampaignObject, firstSortDirection : (typeof sortDirection)["dir"] = "desc") => 
        () => {
            if (col === sortDirection.col) {
                if (sortDirection.dir === "asc") {
                  setSortDirection({ col, dir: "desc" });
                }
        
                if (sortDirection.dir === "desc") {
                  setSortDirection({ col, dir: "asc" });
                }
              } else {
                setSortDirection({ col, dir: firstSortDirection });
              }
        }
    
    type Props = {
        col: keyof AnalysisCampaignObject;
        name: string;
    }
    const SortableHeaderCell = (props:Props) => {
    
        return (
            <TableHeaderCell
                sortDirection={sortDirection.col === props.col && sortDirection.dir}
                onClick={handleSortClick(props.col)}
                textAlign="left"
            >
                {props.name}
            </TableHeaderCell>
        )
    }
    return (
        <>
            <Table>

                <TableHeader>
                    <TableRow>
                        <SortableHeaderCell col={"campaign_name_final"} name={"Campaign Name"}/>
                        <SortableHeaderCell col={"fiscal_year"} name={"FY"}/>
                        <SortableHeaderCell col={"fiscal_quarter"} name={"FQ"}/>
                        <SortableHeaderCell col={"start_date"} name={"Start Date | Days Elapsed"}/>
                        <SortableHeaderCell col={"budget_amount"} name={"Budget"}/>
                        <SortableHeaderCell col={showProjections === "projections" ? "nnl_projected_count" : showProjections === "delta" ? "delta_nnl_count" : "nnl_count"} name={"NNL #"}/>
                        <SortableHeaderCell col={showProjections === "projections" ? "mql_projected_count" : showProjections === "delta" ? "delta_mql_count" : "mql_count"} name={"MQL #"}/>
                        <SortableHeaderCell col={showProjections === "projections" ? "sql_projected_count" : showProjections === "delta" ? "delta_sql_count" : "sql_count"} name={"SQL #"}/>
                        <SortableHeaderCell col={showProjections === "projections" ? "pipe_projected_count" : showProjections === "delta" ? "delta_pipe_count" : "pipe_count"} name={"Pipe #"}/>
                        <SortableHeaderCell col={showProjections === "projections" ? "pipe_projected_amount" : showProjections === "delta" ? "delta_pipe_amount" : "pipe_amount"} name={"Pipe $"}/>
                        {/* <TableHeaderCell>
                            FY
                        </TableHeaderCell>
                        <TableHeaderCell>
                            FQ
                        </TableHeaderCell>
                        <TableHeaderCell>
                            Start Date | Days Elapsed
                        </TableHeaderCell>
                        <TableHeaderCell>
                            Budget
                        </TableHeaderCell>
                        <TableHeaderCell>
                            NNL #
                        </TableHeaderCell>
                        <TableHeaderCell>
                            MQL #
                        </TableHeaderCell>
                        <TableHeaderCell>
                            SQL #
                        </TableHeaderCell>
                        <TableHeaderCell>
                            Pipe #
                        </TableHeaderCell>
                        <TableHeaderCell>
                            Pipe $
                        </TableHeaderCell> */}
                    </TableRow>
                
                </TableHeader>

                <TableBody>
                    {sorted?.map((c) => {
                        return (<AnalysisTableRow campaign={c}/>)
                    })}
                </TableBody>
            </Table>
        </>
    )
})

